// core/services/videosService.ts — local-seed service for the placeholder Videos page.
//
// Videos is a frontend-only placeholder (see nav.ts — "Phase-2, post-backend"), so
// unlike exploreService/followsService this reads from static seed data, not an API
// endpoint, following the same local pattern as creatorsHubService. Follow itself
// still goes through the real followsService/useFollow path (see core/data/videos.ts).
//
// Components must NOT import this directly; use hooks/useVideos.ts.

import type { VideoItem, VideoCreator } from '@/core/models/video';
import { seedVideos, seedVideoCreators } from '@/core/data/videos';

export const videosService = {
  /** All videos (including shorts), seed order. */
  async all(): Promise<VideoItem[]> {
    return seedVideos;
  },

  /** A single video (or short) by id, or null. */
  async byId(id: string): Promise<VideoItem | null> {
    return seedVideos.find((v) => v.id === id) ?? null;
  },

  /** Web-only Shorts rail: items with `short: true`, in seed (ts desc) order. */
  async shorts(): Promise<VideoItem[]> {
    return seedVideos.filter((v) => v.short).sort((a, b) => b.ts - a.ts);
  },

  /** The Top Creators rail. */
  async creators(): Promise<VideoCreator[]> {
    return seedVideoCreators;
  },
} as const;
